import { render, staticRenderFns } from "./LockedInstructions.vue?vue&type=template&id=45f7035b&"
import script from "./LockedInstructions.vue?vue&type=script&lang=js&"
export * from "./LockedInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports